import { ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { ErrorIcon } from "./error-icon";
import { ProTipIcon } from "./pro-tip-icon";

const panelContainerCss = css({
    borderRadius: wacToken("corner.radius.card"),
    backgroundColor: wacToken("color.neutral.light200"),
    padding: `${token("space.300")} ${token("space.400")}`,
    display: "flex",

    [media.below.sm]: {
        flexDirection: "column",
        gap: token("space.100")
    }
});

export type PanelType = "pro-tip" | "highlight";

export interface PanelProps {
    panelType: PanelType;
    label: string;
    description: string | ReactNode;
}

export const Panel = (props: PanelProps) => {
    const isProTip = props.panelType === "pro-tip";
    return (
        <div
            css={[
                panelContainerCss,
                isProTip
                    ? css({ gap: token("space.300") })
                    : css({ gap: token("space.400") })
            ]}
        >
            <div>{isProTip ? <ProTipIcon /> : <ErrorIcon />}</div>
            <div>
                <p
                    className="eyebrow-lg"
                    css={[
                        css({
                            marginBlockStart: `${
                                isProTip ? token("space.100") : "10px"
                            }`
                        }),
                        css({ marginBlockEnd: token("space.100") })
                    ]}
                >
                    {props.label}
                </p>
                <p css={css({ margin: token("space.0") })}>
                    {props.description}
                </p>
            </div>
        </div>
    );
};
